import { Button, Modal } from 'react-bootstrap';
//import React, { useContext, useEffect, useState } from "react";

export default function ConfirmDialog({ show, title, handleDo, handleCancel, isBusy, children, size }) {
    return (
        <Modal show={show} centered onHide={handleCancel} scrollable size={size}>
            <Modal.Header closeButton>
                <Modal.Title className="colorRed">{title}                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                    onClick={handleDo}
                    disabled={isBusy}>
                    {isBusy &&
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>}
                    <span>&nbsp;&nbsp;&nbsp;تایید </span>
                </Button>
                <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                    onClick={handleCancel}>
                    <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}